// Module
var code = "<div ng-controller=\"changes_panel as vm\"\n     style=\"padding-left:10px;\">\n\n    <h2 style=\"margin-bottom:10px;\">{{'CHANGES' | translate}}</h2>\n\n    <div class=\"full-height\" nice-scroll>\n        <vx-list cpi=\"vm.listCpi\"></vx-list>\n    </div>\n</div>";
// Exports
module.exports = code;